//Created by wangshuyi on 07/03/2018.

'use strict';

import dolphinCoreConfig from '../config';

const core = function (config) {
    for (let key in config) {
        Object.assign(dolphinCoreConfig[key], config[key]);
    }
};

core.path = (function () {
    let obj = {}, key;
    for (key in location) {
        if (typeof location[key] !== 'function') {
            obj[key] = location[key];
        }
    }
    obj.contextPath = '';
    obj.apiPath = '/api';
    obj.publicPath = obj.apiPath + '/uploadFiles';
    return obj;
})();

core.addPathParam = function (url, obj) {
    let separation = url.indexOf('?') >= 0 ? '&' : '?';
    for (let key in obj) {
        if (separation === '?') {
            url += `${separation}${key}=${obj[key]}`;
            separation = '&';
        } else {
            url += `${separation}${key}=${obj[key]}`;
        }
    }
    return url;
}
core.replacePathData = function (url, pathData) {
    for (let key in pathData) {
        url = url.replace(`{${key}}`, pathData[key]);
    }
    url = url.replace(/{(\s|_)*}/g, '');

    return url;
}

core.socket = {
    open: false,
    connection: '',
    debug: false,
    options: {path: "/socket.io/"},
};

core.download = (fileName, downloadUrl) => {
    console.log(downloadUrl);
    // 创建隐藏的可下载链接
    let eleLink = document.createElement('a');
    eleLink.download = fileName;
    eleLink.style.display = 'none';
    // 字符内容转变成blob地址
    eleLink.href = encodeURI(downloadUrl);

    if (document.all) {
        eleLink.click();
    } else {
        let evt = document.createEvent("MouseEvents");
        evt.initEvent("click", true, true);
        eleLink.dispatchEvent(evt);
    }
};
core.getFileSize = (num, unit) => {
    num = num || 0;
    unit = unit || 'B';
    let units = ['B', 'K', 'M', 'G'];

    let i = units.findIndex(function (u) {
        return u === unit;
    });
    for (; i < units.length && num > 1024; i++) {
        num = num / 1024;
    }

    return num.toFixed(2) + units[i];
};
core.hideMiddle = (str, prefix = 3, suffix = 4) => {
    let string = str + '';
    let repeatNumber = string.length - prefix - suffix;
    if (repeatNumber <= 0) {
        return string;
    } else {
        return string ? string.substr(0, prefix) + '*'.repeat(repeatNumber) + string.substr(-suffix) : '';
    }
};

core.copy = (text) => {
    let $vue = window.$DolAntPage || window.$DolAntPage;
    return Promise.resolve().then(() => {
        if($vue && $vue.$copyText){
            return clipboardCopy(text, $vue);
        }else{
            return nativeCopy(text);
        }
    }).then(() => {
        if (window.$DolAntPage) {
            window.$DolAntPage.$message.info('复制成功');
        } else if (window.$DolVantPage) {
            window.$DolVantPage.$toast({
                message: '复制成功',
                position: 'top',
            });
        } else {
            alert('复制成功');
        }
    }).catch(e => {
        let msg = '该浏览器不支持点击复制到剪贴板，请手动复制。';
        if (window.$DolAntPage) {
            window.$DolAntPage.$notification.error({
                message: msg,
                description: text,
                duration: null,
                style: {'word-break': 'break-all'}
            });
        } else if (window.$DolVantPage) {
            window.$DolVantPage.$dialog.alert({
                title: msg,
                content: text,
            });
        } else {
            alert(msg);
        }
    });
};
function nativeCopy(text){
    return new Promise((resolve, reject) => {
        let textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            resolve()
        } catch (err) {
            reject();
        }
        document.body.removeChild(textArea);
    });
}
function clipboardCopy(text, $vue){
    return $vue.$copyText(text);
}

core.debounce = (fuc, delay) => {
    let timer;
    return function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            timer = undefined;
            fuc.apply(this, arguments);
        }, delay || 500)
    }
};

import pinyin from 'js-pinyin'

pinyin.setOptions({checkPolyphone: false, charCase: 0});
core.getFirstLetter = str => pinyin.getCamelChars(str);

core.xml2json = require('./Dol-xml2json');

core.formatApi = function (API) {
    let _format = (API, parents) => {
        for (let key in API) {
            if (key === '@extend') {
                let basePath = '/' + parents.join('/');
                if (API[key] === 'list') {
                    API['list'] = basePath + '/list';
                    API['remove'] = basePath + '/remove';
                } else if (API[key] === 'tree') {
                    API['tree'] = basePath + '/tree';
                    API['asyncTree'] = basePath + '/asyncTree';
                    API['getChildrenLength'] = basePath + '/getChildrenLength/{id}';
                }
                API['find'] = basePath + '/find';
                API['count'] = basePath + '/count';
                API['removeOne'] = basePath + '/remove/{id}';
                API['save'] = basePath + '/save/{id}';
                API['detail'] = basePath + '/detail/{id}';
                API['findOne'] = basePath + '/findOne';
                API['importData'] = basePath + '/importData';
                API['exportData'] = basePath + '/exportData';

                delete API[key];
            } else {
                if (typeof API[key] === 'string') {
                    if (/^@/.test(API[key])) {
                        API[key] = '/' + parents.join('/') + API[key].replace('@', '');
                    }
                } else {
                    let _parents = parents.concat([key]);
                    _format(API[key], _parents);
                }
            }
        }
};

    _format(API, []);

    return API;
}

import Base64 from './base64';
core.Base64 = Base64;

core.validate = dolphinCoreConfig.validate;

export default core;
